import { createReducer } from "reduxsauce";
import Immutable from "seamless-immutable";
import { ProviderBankTypes } from "./provider-banks-actions";

export const INITIAL_STATE = Immutable({
  fetchingProviderBankList: null,
  fetchingProviderBanksCount: null,
  providerBankList: null,
  providerBanksCount: null,
  errorProviderBankList: null,
  errorProviderBankCount: null,
  updatingPaystackReveknewBanks: false,
  paystackReveknewBankUpdateResult: null,
  errorPaystackReveknewBankUpdate: null,
});

export const providerBankListRequest = (state) => ({
  ...state,
  fetchingProviderBankList: true,
  providerBankList: null,
});

export const providerBanksCountRequest = (state) => ({
  ...state,
  fetchingProviderBanksCount: true,
  providerBanksCount: null,
});

export const providerBankListSuccess = (state, action) => {
  const { providerBankList } = action;
  return {
    ...state,
    fetchingProviderBankList: false,
    errorProviderBankList: null,
    providerBankList,
  };
};

export const providerBanksCountSuccess = (state, action) => {
  const { count } = action;
  return {
    ...state,
    fetchingProviderBanksCount: false,
    errorProviderBankCount: null,
    providerBanksCount: count,
  };
};

export const providerBankListFailure = (state, action) => {
  const { error } = action;
  return {
    ...state,
    fetchingProviderBankList: false,
    errorProviderBankList: error,
    providerBankList: null,
  };
};

export const providerBanksCountFailure = (state, action) => {
  const { error } = action;
  return {
    ...state,
    fetchingProviderBanksCount: false,
    errorProviderBankCount: error,
    providerBanksCount: null,
  };
};

export const paystackReveknewBankUpdateRequest = (state) => ({
  ...state,
  updatingPaystackReveknewBanks: true,
  paystackReveknewBankUpdateResult: null,
  errorPaystackReveknewBankUpdate: null,
});

export const paystackReveknewBankUpdateSuccess = (state, action) => {
  const { result } = action;
  return {
    ...state,
    updatingPaystackReveknewBanks: false,
    paystackReveknewBankUpdateResult: result,
    errorPaystackReveknewBankUpdate: null,
  };
};

export const paystackReveknewBankUpdateFailure = (state, action) => {
  const { error } = action;
  return {
    ...state,
    updatingPaystackReveknewBanks: false,
    errorPaystackReveknewBankUpdate: error,
  };
};

export const paystackReveknewBankUpdateReset = (state) => ({
  ...state,
  updatingPaystackReveknewBanks: false,
  paystackReveknewBankUpdateResult: null,
  errorPaystackReveknewBankUpdate: null,
});

export const reducer = createReducer(INITIAL_STATE, {
  [ProviderBankTypes.PROVIDER_BANK_LIST_REQUEST]: providerBankListRequest,
  [ProviderBankTypes.PROVIDER_BANKS_COUNT_REQUEST]: providerBanksCountRequest,
  [ProviderBankTypes.PROVIDER_BANK_LIST_SUCCESS]: providerBankListSuccess,
  [ProviderBankTypes.PROVIDER_BANKS_COUNT_SUCCESS]: providerBanksCountSuccess,
  [ProviderBankTypes.PROVIDER_BANK_LIST_FAILURE]: providerBankListFailure,
  [ProviderBankTypes.PROVIDER_BANKS_COUNT_FAILURE]: providerBanksCountFailure,
  [ProviderBankTypes.PAYSTACK_REVEKNEW_BANK_UPDATE_REQUEST]:
    paystackReveknewBankUpdateRequest,
  [ProviderBankTypes.PAYSTACK_REVEKNEW_BANK_UPDATE_SUCCESS]:
    paystackReveknewBankUpdateSuccess,
  [ProviderBankTypes.PAYSTACK_REVEKNEW_BANK_UPDATE_FAILURE]:
    paystackReveknewBankUpdateFailure,
  [ProviderBankTypes.PAYSTACK_REVEKNEW_BANK_UPDATE_RESET]:
    paystackReveknewBankUpdateReset,
});
